import { render } from "./ViewTag.vue?vue&type=template&id=23b42e59&scoped=true"
import script from "./ViewTag.vue?vue&type=script&lang=js"
export * from "./ViewTag.vue?vue&type=script&lang=js"

import "./ViewTag.vue?vue&type=style&index=0&id=23b42e59&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b42e59"]])

export default __exports__